<prlw-preloader-circle-ui [active]="active$ | async"></prlw-preloader-circle-ui>
